import { TYPE_COLLECTION } from './input-types';

export const id = 'externalStatus';
export const apiKey = 'ExternalStatus';
export const type = TYPE_COLLECTION;

export const externalStatus = {
  id,
  apiKey,
  type,
};
